import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="section-anchor w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="reveal lg:col-span-1">
            <span className="text-xs font-label tracking-[0.2em] text-accent-600">常见问题 / FAQ</span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl text-foreground-950">
              关于这部番，你可能想问
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              这里汇总了补番过程中最常出现的疑问，涵盖作品名称、集数、篇章顺序以及各类资源渠道的区别。
            </p>
            <div className="mt-6 rounded-lg bg-background-100 border border-background-200 p-5">
              <p className="text-xs text-foreground-500">还不确定从哪里看起？</p>
              <a
                href="#channels"
                className="mt-2 inline-flex items-center gap-2 text-sm text-primary-700 hover:text-primary-800"
              >
                前往观看渠道说明
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          <div className="reveal lg:col-span-2 space-y-3">
            {faqs.map((f, idx) => {
              const isOpen = open === idx;
              return (
                <div
                  key={f.q}
                  className={`rounded-lg border transition-colors ${
                    isOpen ? "bg-background-100 border-primary-200" : "bg-background-100 border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? null : idx)}
                    className="w-full text-left px-4 md:px-5 py-4 flex items-center gap-3"
                  >
                    <span className="shrink-0 w-7 h-7 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center text-xs font-label">
                      Q
                    </span>
                    <span className="flex-1 text-sm md:text-base text-foreground-900 leading-relaxed">{f.q}</span>
                    <i
                      className={`shrink-0 transition-transform duration-300 ${
                        isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                      } text-lg text-foreground-500`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-4 md:px-5 pb-5 pl-14 md:pl-16">
                      <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}